"use client";

import React from "react";
import Image from "next/image";
import styles from "./CompareToast.module.scss";
import Button from "@components/atoms/Button";
import Text from "@components/atoms/Text";
import { useHasBottomNav } from "@hooks/useHasBottomNav";
import assetLoader from "@utils/internalImageLoder";
import { CompareToastState } from "@hooks/useCompareToast";

interface CompareToastProps {
  toast: CompareToastState;
  onClose: () => void;
}

const CompareToast = ({ toast, onClose }: CompareToastProps) => {
  const hasBottomNav = useHasBottomNav();

  if (!toast.show) return null;

  const getIcon = () => {
    switch (toast.type) {
      case "error":
        return `${assetLoader()}/icons/alert_error_info.svg`;
      case "success":
        return `${assetLoader()}/icons/checked_light.svg`;
      default:
        return `${assetLoader()}/icons/alert_error_info.svg`;
    }
  };

  return (
    <div
      className={`${styles.compareToast} ${
        hasBottomNav ? styles.hasBottomNav : styles.hasNotBottomNav
      }`}
    >
      <div className={styles.compareToast_iconText}>
        <Image
          src={getIcon()}
          alt={toast.type === "error" ? "Error" : "Success"}
          width={20}
          height={20}
          loading="lazy"
        />
        <Text className={styles.compareToast_Text}>{toast.message}</Text>
      </div>
      <Button
        className={styles.compareToast_button}
        onButtonClick={onClose}
        ariaLabel="Close toast"
      >
        Got it
      </Button>
    </div>
  );
};

export default CompareToast;
